// Vendors
import jquery from 'jquery/dist/jquery.js';

// Modules
import burgerMenu from './modules/navigation-menu.js';
import clock from './modules/hours-clock.js';

// Styles
import styles from '../css/common.scss';

// document.addEventListener('keydown', function(event) {
//     // Check if the key pressed is Tab (key code 9)
//     if (event.key === 'Tab') {
//         setTimeout(() => {
//             console.log('Current focused element:', document.activeElement);
//         }, 0); // Timeout of 0 to ensure focus change has been processed
//     }
// });


document.querySelectorAll('.dz-message button').forEach(button => {
    button.addEventListener('focus', () => {
        button.closest('.dz-message').classList.add('focused');
    });
    button.addEventListener('blur', () => {
        button.closest('.dz-message').classList.remove('focused');
    });
});

function reservationsPageAnchor(){
    const reservationBtn = document.querySelector('.reservation-anchor-btn');
    const risolabForm = document.querySelector('.risolab-request-form');

    function scrollToRisolabForm() {
        if (risolabForm) {
            const formOffsetTop = risolabForm.getBoundingClientRect().top + window.pageYOffset;
            const formComputedStyle = window.getComputedStyle(risolabForm);
            const formMarginTop = parseInt(formComputedStyle.marginTop, 10);

            window.scrollTo({
                top: formOffsetTop - formMarginTop,
                behavior: 'smooth'
            });
        }
    }

    // Check for the ?login=success query parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('login') === 'success') {
        window.setTimeout(function(){
            scrollToRisolabForm();
        }, 1000)
    }

    if (reservationBtn) {
        reservationBtn.addEventListener('click', function(event) {
            event.preventDefault();
            scrollToRisolabForm();
        });
    }
}


reservationsPageAnchor();

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}
